import {
    NDDFilterConfigOperators,
    NDDFilterOperatorsByTypes,
} from '../ndd-ng-filter/shared/models/ndd-ng-filter-operators.model';
import {
    INDDFilterLogicalOperator,
    INDDFilterOperator,
} from '../ndd-ng-filter/shared/models/ndd-ng-filter-state.model';
import {
    NDDFilterLogicalOperatorsTypes,
    NDDFilterOperatorValues,
} from '../ndd-ng-filter/shared/models/ndd-ng-filter.enum';

/**
* FilterConfigOperators são os operadores disponíveis junto com o texto.
*
* Para o valor, está no enumerador NDDFilterOperatorValues.
* Esses operadores podem ser substituidos nas configs das rules;
*
* @export
* @class FilterConfigOperators
* @implements NDDFilterConfigOperators
*/
export class FilterConfigOperators implements NDDFilterConfigOperators {
    public static equals: INDDFilterOperator = { text: '360Equals', value: NDDFilterOperatorValues.Equals };

    public static different: INDDFilterOperator = { text: '360Different', value: NDDFilterOperatorValues.Different };

    public static contains: INDDFilterOperator = { text: '360Contains', value: NDDFilterOperatorValues.Contains };

    public static startsWith: INDDFilterOperator = { text: '360StartsWith', value: NDDFilterOperatorValues.StartsWith };

    public static endsWith: INDDFilterOperator = { text: '360EndsWith', value: NDDFilterOperatorValues.EndsWith };

    public static greaterThan: INDDFilterOperator = { text: '360GreaterThan', value: NDDFilterOperatorValues.GreaterThan };

    public static greaterThanOrEquals: INDDFilterOperator = { text: '360GreaterThanOrEqual', value: NDDFilterOperatorValues.GreaterThanOrEquals };

    public static lessThan: INDDFilterOperator = { text: '360LessThan', value: NDDFilterOperatorValues.LessThan };

    public static lessThanOrEqual: INDDFilterOperator = { text: '360LessThanOrEqual', value: NDDFilterOperatorValues.LessThanOrEqual };

    public static interval: INDDFilterOperator = { text: '360Interval', value: NDDFilterOperatorValues.Interval };
}

/**
* FilterConfigLogicalOperators são os operadores lógicos disponíveis junto com o texto.
*
*  Para o valor, está no enumerador NDDFilterLogicalOperatorsTypes
*
* @export
* @class FilterConfigLogicalOperators
*/
export class FilterConfigLogicalOperators {
    public static and: INDDFilterLogicalOperator = { text: '360And', value: NDDFilterLogicalOperatorsTypes.And };
    public static or: INDDFilterLogicalOperator = { text: '360Or', value: NDDFilterLogicalOperatorsTypes.Or };
    public static none: INDDFilterLogicalOperator = { text: '360None', value: NDDFilterLogicalOperatorsTypes.None };

    public static readonly availableOperators: INDDFilterLogicalOperator[] = [
        FilterConfigLogicalOperators.and,
        FilterConfigLogicalOperators.or,
    ];
}

/**
*  A classe FilterConfigOperatorValuesByType é um facilitador
*
*  Ela serve para agrupar por tipo os operadores padrão.
*  Esses operadores podem ser substituidos nas configs das rules;
*
* @export
* @class FilterConfigOperatorValuesByType
*/
export class FilterConfigOperatorValuesByType implements NDDFilterOperatorsByTypes {

    public readonly stringType: INDDFilterOperator[] =
        [
            FilterConfigOperators.equals,
            FilterConfigOperators.different,
            FilterConfigOperators.contains,
            FilterConfigOperators.startsWith,
            FilterConfigOperators.endsWith,
        ];

    public readonly booleanType: INDDFilterOperator[] =
        [
            FilterConfigOperators.equals,
            FilterConfigOperators.different,
        ];

    public readonly timeType: INDDFilterOperator[] =
        [
            FilterConfigOperators.equals,
            FilterConfigOperators.different,
            FilterConfigOperators.interval,
            FilterConfigOperators.greaterThan,
            FilterConfigOperators.greaterThanOrEquals,
            FilterConfigOperators.lessThan,
            FilterConfigOperators.lessThanOrEqual,
            FilterConfigOperators.lessThanOrEqual,
        ];

    public readonly numberType: INDDFilterOperator[] =
        [
            FilterConfigOperators.equals,
            FilterConfigOperators.different,
            FilterConfigOperators.interval,
            FilterConfigOperators.greaterThan,
            FilterConfigOperators.greaterThanOrEquals,
            FilterConfigOperators.lessThan,
            FilterConfigOperators.lessThanOrEqual,
            FilterConfigOperators.lessThanOrEqual,
        ];

    public readonly untyped: INDDFilterOperator[] =
        [
            FilterConfigOperators.equals,
        ];
}
